import PadraoModel from 'src/core/model/PadraoModel.js'

export default class SituacaoLocalModel extends PadraoModel {
  recurso = 'situacoes-locais'
  microServico = 'usuario'
  include = null
  searchFixo = null
  nome = 'Situações Local'

  colunasGrid = []

  form = {}

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
